// Concierge: the team sets up the account for the user, paid by Pix.
// Shown from the onboarding banner and from the cancellation flow; after payment the user
// talks to the team on WhatsApp.

// The sales team's WhatsApp, not the support number in the site footer.
const CONCIERGE_WHATSAPP_NUMBER = '5511919001841'

// Brazil only (.com.br): priced in BRL and served by a Portuguese-speaking team. Portuguese
// on another domain (galilai.com/pt) is not enough. Localhost follows the language for testing.
function isConciergeAvailable() {
    let host = window.location.hostname
    if (host == 'localhost' || host == '127.0.0.1') {
        return typeof getCurrentLanguage == 'function' && getCurrentLanguage() == 'pt'
    }
    return host.endsWith('.com.br')
}

// The team finds the account by id. The editor keeps it in $rootScope.userConfig.user, the
// profile page in its own global userConfig, and both cache it in localStorage.
function getConciergeUserId($rootScope) {
    let id = $rootScope?.userConfig?.user?.id
    if (!id && typeof userConfig != 'undefined') {
        id = userConfig?.userId || userConfig?.user?.id
    }
    if (!id) {
        try {
            id = localStorage.getItem('auth.user.id')
        } catch (e) {}
    }
    return id || '-'
}

angular.module('galilai.creator').factory('concierge', function(api, $rootScope) {
    return {
        track: function(action, context) {
            context = context || {}
            api.trackConcierge({
                action: action,
                origin: context.origin,
                reason: context.reason || null,
            }).catch(function() {})
        },
        whatsappUrl: function(context) {
            context = context || {}
            let message
            if (context.paid) {
                message = gettext('concierge.whatsapp_message_setup_paid')
            } else {
                message = gettext('concierge.whatsapp_message_setup_check')
            }
            message = message.replace('{userId}', context.userId || getConciergeUserId($rootScope))
            return 'https://wa.me/' + CONCIERGE_WHATSAPP_NUMBER + '?text=' + encodeURIComponent(message)
        },
    }
})

// The setup offer: paid by Pix first, then opens WhatsApp. `highlight` marks it as recommended
// for the cancellation reason.
const CONCIERGE_PIX_POLL_MS = 3000
// After this the screen stops waiting and points to the team; a later payment is still
// recorded by the server and emailed to the team.
const CONCIERGE_PIX_POLL_MAX_MS = 30 * 60 * 1000

angular.module('galilai.creator').directive('conciergeOffers', function(concierge, api, $interval, $timeout) {
    return {
        restrict: 'E',
        scope: {
            origin: '@',
            reason: '<?',
            reasonLabel: '<?',
            highlight: '<?',
        },
        // Buttons carry flex: none because the app theme gives .btn flex: 1, which stretches
        // them inside the card's flex column.
        template: `
            <div class="concierge-offers">
                <div class="row g-3 justify-content-center" ng-if="view.step == 'cards'">
                    <div class="col-12 col-md-8">
                        <div class="card h-100" ng-class="highlight == 'setup' ? 'border-primary border-2 shadow' : 'border'">
                            <div class="card-body d-flex flex-column">
                                <div ng-if="highlight == 'setup'"><span class="badge bg-primary mb-2">[[gettext('concierge.recommended')]]</span></div>
                                <h5 class="card-title mb-1">[[gettext('concierge.setup_title')]]</h5>
                                <div class="mb-2"><span class="fs-4 fw-bold">[[gettext('concierge.setup_price')]]</span> <small class="text-muted">[[gettext('concierge.setup_price_note')]]</small></div>
                                <p class="card-text small mb-1">[[gettext('concierge.setup_desc')]]</p>
                                <p class="small text-muted flex-grow-1"><span ng-if="origin != 'cancel'">[[gettext('concierge.setup_discount')]]</span></p>
                                <button type="button" class="btn btn-primary w-100" style="flex: none" ng-disabled="view.loading" ng-click="startSetupPix()">
                                    <span ng-if="view.loading" class="spinner-border spinner-border-sm me-1"></span>[[gettext('concierge.setup_cta')]]
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div ng-if="view.step == 'pix'" class="text-center">
                    <h5 class="mb-1">[[gettext('concierge.pix_title')]]</h5>
                    <p class="small text-muted mb-2">[[gettext('concierge.pix_instructions')]]</p>
                    <img ng-src="data:image/png;base64,[[view.pix.encodedImage]]" class="img-fluid mb-2" style="max-width: 220px" alt="">
                    <div class="input-group mb-2 mx-auto" style="max-width: 420px">
                        <input type="text" class="form-control" readonly ng-value="view.pix.payload" onclick="this.select()">
                        <button type="button" class="btn btn-outline-primary" style="flex: none" ng-click="copyPix()">
                            [[view.copied ? gettext('concierge.pix_copied') : gettext('concierge.pix_copy')]]
                        </button>
                    </div>
                    <div class="small text-muted" ng-if="!view.timedOut"><span class="spinner-border spinner-border-sm me-1"></span>[[gettext('concierge.pix_waiting')]]</div>
                    <div ng-if="view.timedOut">
                        <p class="small text-muted mb-2">[[gettext('concierge.pix_timeout')]]</p>
                        <a class="btn btn-success btn-sm" style="flex: none" ng-href="[[checkWhatsappUrl()]]" target="_blank" rel="noopener" ng-click="clickPaidWhatsapp()">
                            <i class="mdi mdi-whatsapp me-1"></i>[[gettext('concierge.pix_timeout_cta')]]
                        </a>
                    </div>
                    <button type="button" class="btn btn-link btn-sm mt-2" ng-click="backToCards()">[[gettext('concierge.pix_back')]]</button>
                </div>

                <div ng-if="view.step == 'paid'" class="text-center py-2">
                    <i class="mdi mdi-check-circle text-success" style="font-size: 48px"></i>
                    <h5 class="mt-1">[[gettext('concierge.paid_title')]]</h5>
                    <p class="small text-muted">[[gettext('concierge.paid_desc')]]</p>
                    <a class="btn btn-success" style="flex: none" ng-href="[[paidWhatsappUrl()]]" target="_blank" rel="noopener" ng-click="clickPaidWhatsapp()">
                        <i class="mdi mdi-whatsapp me-1"></i>[[gettext('concierge.paid_cta')]]
                    </a>
                </div>
            </div>
        `,
        link: function(scope) {
            scope.gettext = gettext
            scope.view = { step: 'cards', loading: false, pix: null, copied: false, userId: null, timedOut: false }
            let poll = null
            let pollStartedAt = 0

            function context(extra) {
                return Object.assign({
                    origin: scope.origin,
                    reason: scope.reason,
                    reasonLabel: scope.reasonLabel,
                }, extra || {})
            }

            function stopPolling() {
                if (poll) {
                    $interval.cancel(poll)
                    poll = null
                }
            }

            function startPolling(jobId) {
                stopPolling()
                pollStartedAt = Date.now()
                poll = $interval(function() {
                    if (Date.now() - pollStartedAt > CONCIERGE_PIX_POLL_MAX_MS) {
                        stopPolling()
                        scope.view.timedOut = true
                        return
                    }
                    api.getJob(jobId).then(function(res) {
                        let status = res?.data?.status
                        if (status == 'success') {
                            stopPolling()
                            scope.view.step = 'paid'
                            scope.$emit('concierge.paid')
                        } else if (status && status != 'pending') {
                            stopPolling()
                            scope.view.step = 'cards'
                            showError(gettext('concierge.pix_error'))
                        }
                    }).catch(function() {
                        // A failed check is retried on the next tick.
                    })
                }, CONCIERGE_PIX_POLL_MS)
            }

            scope.checkWhatsappUrl = function() {
                return concierge.whatsappUrl(context({ card: 'setup', paymentCheck: true, userId: scope.view.userId }))
            }

            scope.paidWhatsappUrl = function() {
                return concierge.whatsappUrl(context({ card: 'setup', paid: true, userId: scope.view.userId }))
            }

            scope.clickPaidWhatsapp = function() {
                concierge.track('click_whatsapp', context())
            }

            scope.startSetupPix = function() {
                concierge.track('click_setup', context())
                scope.view.loading = true
                api.createConciergeSetupPix({
                    origin: scope.origin,
                    reason: scope.reason || null,
                }).then(function(res) {
                    let data = res?.data?.data
                    if (!data || !data.jobId || !data.payload) {
                        throw new Error('no pix')
                    }
                    scope.view.pix = data
                    scope.view.userId = data.userId
                    scope.view.copied = false
                    scope.view.step = 'pix'
                    scope.view.timedOut = false
                    startPolling(data.jobId)
                }).catch(function() {
                    showError(gettext('concierge.pix_error'))
                }).finally(function() {
                    scope.view.loading = false
                    $timeout(angular.noop)
                })
            }

            scope.copyPix = function() {
                let text = scope.view.pix?.payload || ''
                let done = function() {
                    scope.view.copied = true
                    $timeout(angular.noop)
                }
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(text).then(done).catch(function() {})
                } else {
                    let input = document.createElement('textarea')
                    input.value = text
                    document.body.appendChild(input)
                    input.select()
                    try {
                        document.execCommand('copy')
                        done()
                    } catch (e) {}
                    document.body.removeChild(input)
                }
            }

            scope.backToCards = function() {
                stopPolling()
                scope.view.step = 'cards'
            }

            // Closing the modal keeps polling, so a payment made right after still flips to "paid"
            // when it is reopened; leaving the cancel step destroys the scope and stops it.
            scope.$on('$destroy', stopPolling)
        },
    }
})

// Modal opened by the onboarding banner.
angular.module('galilai.creator').controller('ConciergeController', function($scope, $rootScope, concierge, $timeout) {
    $scope.gettext = gettext
    $scope.isConciergeAvailable = isConciergeAvailable
    $scope.paid = false
    $scope.$on('concierge.paid', function() {
        $scope.paid = true
    })
    let modal = null

    $rootScope.openConcierge = function(origin) {
        $scope.origin = origin || 'banner'
        let el = document.getElementById('concierge-modal')
        if (!el) {
            return
        }
        if (!modal) {
            modal = bootstrap.Modal.getOrCreateInstance(el)
            // Covers the X, the backdrop and the footer link alike.
            el.addEventListener('hidden.bs.modal', function() {
                concierge.track('close', { origin: $scope.origin })
            })
        }
        modal.show()
        concierge.track('view', { origin: $scope.origin })
        $timeout(angular.noop)
    }

    $scope.dismiss = function() {
        if (modal) {
            modal.hide()
        }
    }
})

// Hooks for the onboarding banner, which lives in another controller's scope.
angular.module('galilai.creator').run(function($rootScope, concierge) {
    let impressions = {}
    $rootScope.trackConciergeImpression = function(origin) {
        // Once per page load; the server keeps only the first one per user anyway.
        if (!impressions[origin]) {
            impressions[origin] = true
            concierge.track('impression', { origin: origin })
        }
    }
    $rootScope.trackConciergeSelf = function(origin) {
        concierge.track('click_self', { origin: origin })
    }
})
